
































import moment from 'moment';
import _ from 'lodash';
import Vue from 'vue';
import { mapGetters } from 'vuex';

import i18n from '@/i18n';
import investigationAPI from '@/vuex/investigation/investigationAPI';
import { criteriaToQueryString } from '@/lib/criteria';

export default Vue.extend({
  props: {
    criteria: Object,
  },
  data() {
    return {
      loading: false,
      error: null as any,

      finalizedInLastNDays: 90,

      results: [],
    };
  },
  computed: {
    ...mapGetters('language', ['nameForIDInCollection']),

    items(): any[] {
      return _.map(this.results, (row: any) => {
        return {
          ...row,
          avgDuration: (row.avgDuration || 0).toFixed(1),
          lawsuitType: this.nameForIDInCollection(
            row.lawsuitTypeID,
            'court/lawsuitTypes',
          ),
        };
      });
    },

    /**
     * headers computes the array of column header definitions for the
     * v-data-table. It needs to be a computed property so
     * that it will update with new translations when the locale changes.
     */
    headers(): any[] {
      return [
        { text: i18n.t('lawsuitType.singular'), value: 'lawsuitType' },
        {
          text: '# ' + i18n.t('dossier.plural'),
          value: 'dossierCount',
          align: 'right',
        },
        { text: i18n.t('duration.avg'), value: 'avgDuration', align: 'right' },
      ];
    },

    /**
     * fullCriteria builds the actual API criteria which will be sent. This is
     * done by combining the incoming criteria prop with customizations set
     * directly on this component.
     */
    fullCriteria(): any {
      const criteria = Object.assign({}, this.criteria, {
        activeOnly: false,
      });
      if (this.finalizedInLastNDays > 0) {
        criteria.disposedAtOrAfter = moment()
          .subtract(this.finalizedInLastNDays, 'days')
          .format();
      }
      return criteria;
    },

    /**
     * queryString builds the URL querystring which will be sent to the API
     * endpoint. It exists as a standalone computed prop so that the watcher
     * can trigger only when the query has changed.
     */
    queryString(): string {
      return criteriaToQueryString(this.fullCriteria);
    },
  },
  watch: {
    /**
     * queryString is watched so that any change the API parameters will
     * trigger a new data fetch.
     */
    queryString: {
      immediate: true,
      handler() {
        this.fetchData();
      },
    },
  },

  methods: {
    async fetchData(): Promise<void> {
      this.loading = true;
      this.error = null;
      const url = `/dossiers/by-lawsuit-type?${this.queryString}`;

      try {
        const response = await investigationAPI.get(url);
        this.results = _.get(response, 'data.data', []);
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
});
